const messenger = {
  messageGroupList: 'MessageGroup/getlist',
  messageGroupAll: 'MessageGroup/getall',
  addMessageGroup: 'MessageGroup/add',
  updateMessageGroup: 'MessageGroup/update',
  get: 'MessageGroup/get',
  messageGroupUserList: 'MessageGroupUsers/getlist',
  addMessageGroupUser: 'MessageGroupUsers/add',
  removeMessageGroupUser: 'MessageGroupUsers/remove',
  messageReportList: 'MessageReport/getlist',
  removeMessageReport: 'messagereport/remove',
  applyMessageReport: 'messagereport/applyReport',
  setPinMessage: 'message/Pin',
  GetPinMessage:'message/pinnedList',
  ScheduleMessageList:"ScheduleMessage/GetList",
  ScheduleMessageGetALL:"ScheduleMessage/GetAll",
  ScheduleMessageSet:'ScheduleMessage/Add',
  ScheduleMessageUpdate:'/ScheduleMessage/Update',
  ScheduleMessageRemove:'/ScheduleMessage/Remove',
  ScheduleMessageGet:'ScheduleMessage/Get',

}
export default messenger